import EncryptionField from '@/components/EncryptionField/index.vue';
import { searchSiteIdList } from '@/api/lanshou';
import {
  apiCustomerListPage,
  apiCustomerStateHandler,
  apiResetPassword,
  exportCustomerList,
  getCustomerChannelList,
  getCustomerTree,
  inviterCustomer
} from '@/api/customer';
// import { apiAddressBook } from '@/api/orderApi';
import { getUserIdAndNameObj } from '@/enums/storageEnum';
import { getUserName } from '@/utils/asyncTools';
import { TYPY_OBJ } from '@/enums/customerEnums';
import { priceType } from '@/utils/validate';
import { NODE_TYPE } from '@/enums/messageRecordEnums';
import { goResourceTaskList } from '@/utils/goExportList';
// import { currencyTypePage, changeCreditLimit } from '@/api/finance/partition';
import { copyData } from '@/utils/copyData';

export default {
  name: 'CustomerList',
  components: {
    EncryptionField,
    // 'customer-cmp': CustomerCmp
    'tab-cmp': () => import('./TabsCmp'),
    'reset-pwd-cmp': () => import('./cmp/ResetPwdCmp'),
    InviteToRegister: () => import('./cmp/InviteToRegister.vue')
    // 'msg-cmp': () => import('@/components/SendMessage/index')
  },

  data() {
    return {
      isShow: false,
      drawerObj: {
        title: '新增客户',
        customerType: {
          id: '', // 客户id
          customerAlias: '', // 客户别名
          channel: '', // 客户渠道
          type: ''
        }
      },
      drawerObjVisible: false,
      queryForm: {
        pageSize: 20,
        pageNumber: 1,
        params: {
          source: '',
          id: '',
          username: '',
          company: '',
          siteId: '',
          cnpjMother: '',
          lockState: null,
          auditState: null,
          customerChannelList: []
        }
      },
      siteIdList: [], // 站点list

      tableData: [],
      total: 0,

      userObj: [],

      typeObj: TYPY_OBJ,
      // queryBoxShow: true,

      resetPwdObj: {
        visible: false,
        ids: 0
      },
      sendArr: [], // 手机人地址簿
      recharge: {
        creditLimit: '', // 信用额度
        rechargeAmount: '' // 充值金额
      },
      rechargeType: 1,
      showType: false,
      rechargeId: 1,
      rules: {
        creditLimit: [{ required: true, validator: priceType, trigger: ['blur', 'change'] }],
        rechargeAmount: [{ required: true, validator: priceType, trigger: ['blur', 'change'] }]
      },

      msgArr: [], // 发送信息
      currencyObj: [], // 币种
      channelList: [], // 客户渠道list
      dataTree: [],
      defaultProps: {
        children: 'children',
        label: 'username'
      }
    };
  },

  created() {
    this.getData(1);
    this.userObj = getUserIdAndNameObj();

    this.NODE_TYPE = NODE_TYPE;

    searchSiteIdList().then((res) => {
      if (res.code === 200) {
        res.data.forEach((data) => {
          this.siteIdList.push({ id: data.id, name: data.name });
        });
      }
    });
  },

  methods: {
    onClickNode(data) {
      console.log(data, 'onClickNode');
      // @click.stop="(scope.row, typeObj.examine.code, scope.$index)"
      this.goPage(data, this.typeObj.examine.code);
    },
    // 点击复制
    copy(data) {
      copyData(data);
    },
    // 邀请注册
    async showRegisterDialog() {
      const res = await inviterCustomer();
      if (res.code === 200) {
        console.log(res, 'inviterCustomer');
        const timestamp = new Date().getTime();
        const baseUrl = process.env.VUE_APP_INVITE_URL;
        const inviteUrl = `${baseUrl}/#/shareInvitationPage?invitation_id=${res.data}&timestamp=${timestamp}`;
        // const inviteUrl = `http://192.168.2.84:9528/#/shareInvitationPage?invitation_id=${res.data}&timestamp=${timestamp}`;
        this.$refs.InviteToRegisterRef.showRegisterDialog(inviteUrl);
      }
    },
    // 导出
    exportTableData() {
      const paramForm = JSON.parse(JSON.stringify(this.queryForm));
      paramForm.params.cnpjMother = this.queryForm.params.cnpjMother.replace(/[^0-9a-zA-Z]/g, '');
      exportCustomerList(paramForm.params).then((res) => {
        if (res.code === 200) {
          goResourceTaskList();
        }
      });
    },
    idInput(value) {
      this.queryForm.params.id = value.replace(/[^\d]/g, '');
    },
    changeCnpjMother(value) {
      this.queryForm.params.cnpjMother = value.replace(/[\u4e00-\u9fa5]/g, '');
    },
    // 充值、修改信用额度
    rechargeClick(id, type) {
      this.rechargeId = id;
      this.rechargeType = type;
      this.showType = true;
    },

    getData(find) {
      if (find === 1) {
        this.queryForm.pageNumber = 1;
      }
      const paramForm = JSON.parse(JSON.stringify(this.queryForm));
      paramForm.params.cnpjMother = this.queryForm.params.cnpjMother.replace(/[^0-9a-zA-Z]/g, '');
      this.getCustomerTreeData(paramForm);
      apiCustomerListPage(paramForm)
        .then((res) => {
          if (res.code === 200) {
            this.total = res.data.total;
            this.tableData = res.data.records.map((item) => {
              const creatUserName = getUserName(item.createUser, this.userObj);
              return {
                ...item,
                creatUserName,
                integral: item.integral || 0,
                level: item.level || 0
              };
            });
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    async getCustomerTreeData(data) {
      const res = await getCustomerTree(data.params);
      if (res.code === 200) {
        this.dataTree = res.data;
      }
    },
    /**
     * 置空
     */
    queryFormReset() {
      for (const key in this.queryForm.params) {
        this.queryForm.params[key] = key === 'customerChannelList' ? [] : '';
      }
      this.getData(1);
    },
    // 新增账号状态启用停用控制
    accountStatus(row, status) {
      console.log(row, 'accountStatus');
      // status: 0 启用，1 停用
      const actionText =
        status === 0
          ? this.$t('ChannelManage.confirmActivateAccount')
          : this.$t('ChannelManage.confirmDeactivateAccount');
      this.$confirm(`${actionText}`, this.$t('customerManagements.AccountStatus'), {
        confirmButtonText: this.$t('customerManagements.confirm'),
        cancelButtonText: this.$t('customerManagements.cancel'),
        type: 'warning'
      })
        .then(() => {
          const data = {
            type: status,
            status: status,
            idList: [row.id]
          };
          apiCustomerStateHandler(data)
            .then((res) => {
              if (res.code === 200) {
                this.$message.success(this.$t('GlobalSetObj.TheOperationSucceeded'));
                this.getData(1);
              }
            })
            .catch((err) => {
              console.error(err);
            });
        })
        .catch(() => {});
    },
    // 账号审核
    accountReview(row) {
      // 提示文案：备注中「停用」直接展示，不做样式处理
      const confirmContent = this.$createElement('div', { class: 'account-review-confirm' }, [
        this.$createElement(
          'div',
          { class: 'account-review-title' },
          this.$t('customerManagements.IfAgreeAudit')
        ),
        this.$createElement(
          'div',
          { class: 'account-review-desc' },
          this.$t('customerManagements.accountStatusNote')
        )
      ]);
      this.$confirm(confirmContent, this.$t('GlobalSetObj.tips'), {
        confirmButtonText: this.$t('customerManagements.confirm'),
        cancelButtonText: this.$t('customerManagements.cancel'),
        type: 'warning',
        dangerouslyUseHTMLString: true
      })
        .then(() => {
          const data = {
            type: 2,
            status: 1,
            idList: [row.id]
          };
          apiCustomerStateHandler(data)
            .then((res) => {
              if (res.code === 200) {
                this.$message.success(this.$t('GlobalSetObj.TheOperationSucceeded'));
                this.getData(1);
              }
            })
            .catch((err) => {
              console.error(err);
            });
        })
        .catch(() => {});
    },
    /**
     * 跳转到详情或者新增页面
     */
    goPage({ id, customerAlias, deliveryNoteFlag, channel }, type, index) {
      this.drawerObjVisible = true;
      this.drawerObj.customerType.id = id;
      this.drawerObj.customerType.type = type;
      this.drawerObj.customerType.customerAlias = customerAlias;
      this.drawerObj.customerType.deliveryNoteFlag = deliveryNoteFlag;
      this.drawerObj.customerType.channel = channel;
      // this.drawerObj.title = TYPY_OBJ[type].name;

      if (type === TYPY_OBJ.add.code) {
        // 新增
        this.drawerObj.title = this.$t('customerManagements.add');
        this.$store.dispatch('user/getManagerList', '');
      } else if (type === TYPY_OBJ.edit.code) {
        this.drawerObj.title = this.$t('customerManagements.edit');
        // 判断有没有经办人，没有请求第一页列表
        if (index && this.tableData[index].handlerId) {
          this.$store
            .dispatch('user/getManagerList', this.tableData[index].handlerName)
            .then((res) => {
              this.getData(1);
            });
        } else {
          this.$store.dispatch('user/getManagerList', '');
        }
        // 编辑
      } else if (type === TYPY_OBJ.examine.code) {
        this.drawerObj.title = this.$t('customerManagements.View');
        // 判断有没有经办人，没有请求第一页列表
        if (index && this.tableData[index].handlerId) {
          this.$store.dispatch('user/getManagerList', this.tableData[index].handlerName);
          this.getData(1);
        } else {
          this.$store.dispatch('user/getManagerList', '');
        }
        // 查看
      } else {
        this.drawerObj.title = this.$t('customerManagements.Approval');
        console.log(type);
      }
    },
    closeDrawer() {
      this.drawerObjVisible = false;
    },
    updataData(isBool = true) {
      this.getData();
      if (isBool) {
        this.drawerObjVisible = false;
      }
    },

    // 重置
    handleResetPwd(ids) {
      console.log(ids, 'idsids');
      this.resetPwdObj.ids = ids;
      this.resetPwdObj.visible = true;
    },

    // 修改密码
    handleDetermine(obj) {
      apiResetPassword(obj)
        .then((res) => {
          if (res.code !== 200) {
            return;
          }
          this.$message({
            message: this.$t('customerManagements.resetSucceeded'), // 重置密码成功
            type: 'success'
          });
          this.resetPwdObj.visible = false;
          this.getData(find);
        })
        .catch((err) => {
          console.error(err);
        });
    },
    getChannelData() {
      if (this.channelList.length <= 0) {
        this.getChannel();
      }
    },
    getChannel() {
      getCustomerChannelList().then((res) => {
        if (res.code === 200) {
          this.channelList = res.data || [];
        }
      });
    }
  }
};
